import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ktostamm-kunde-subnummer-detail-view',
  imports: [],
  templateUrl: './ktostamm-kunde-subnummer.detail-view.html',
  styleUrls: ['./ktostamm-kunde-subnummer.detail-view.css'],
})
export class KtostammKundeSubnummerDetailView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
